import { render, staticRenderFns } from "./work-order-sent-pg.vue?vue&type=template&id=ac2a8bd0&scoped=true"
import script from "./work-order-sent-pg.vue?vue&type=script&lang=js"
export * from "./work-order-sent-pg.vue?vue&type=script&lang=js"
import style0 from "./work-order-sent-pg.vue?vue&type=style&index=0&id=ac2a8bd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2a8bd0",
  null
  
)

export default component.exports